import React from "react";
import { MarketingNav, MarketingFooter } from "@/components/marketing/MarketingChrome";
import { PricingTable, EnterpriseEnquiry } from "@/components/marketing/PricingTable";

export default function Pricing() {
  return (
    <div className="marketing-root min-h-screen bg-[color:var(--marketing-bg)] text-[color:var(--marketing-text)]">
      <MarketingNav active="Pricing" />
      <main data-testid="pricing-page" className="mx-auto max-w-7xl px-6 py-20 lg:px-10 lg:py-24">
        <p className="overline-label">Pricing</p>
        <h1 className="mt-4 max-w-3xl font-marketing-display text-4xl font-black leading-none tracking-tight sm:text-5xl">
          Governance-grade delivery, at PMO prices.
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-[color:var(--marketing-text-muted)]">
          Foundation gets a small team working the same way. Professional is where most PMOs settle — the
          full governance, planning and assurance toolset, per person, per month. Enterprise adds the data
          boundary controls and evidence that regulated and public sector buyers are obliged to ask for.
          Nothing here needs a nine-month implementation to become useful.
        </p>
        <div className="mt-14">
          <PricingTable />
        </div>
        <div id="enquiry" className="mt-24 scroll-mt-24">
          <EnterpriseEnquiry />
        </div>
      </main>
      <MarketingFooter />
    </div>
  );
}
